import { get, patch, post } from 'helpers/api';
import { camelCase } from 'lodash';

export const END_CREATING_RECORDS = 'END_CREATING_RECORDS';
export function endCreatingRecords() {
  return { type: END_CREATING_RECORDS };
}

export const SET_RECORDS = 'SET_RECORDS';
export function setRecords(records, recordIds, meta, headers, importSummary) {
  return { records, recordIds, meta, headers, importSummary, type: SET_RECORDS };
}

export const START_RETRIEVE_RECORDS = 'STAR_RETRIEVE_RECORDS';
export function startRetrieveRecords() {
  return { type: START_RETRIEVE_RECORDS };
}

export const TOGGLE_SKIP_RECORD = 'TOGGLE_SKIP_RECORD';
export function toggleSkipRecord(recordId) {
  return { recordId, type: TOGGLE_SKIP_RECORD };
}

export const TOGGLE_SKIP_ALL_RECORDS = 'TOGGLE_SKIP_ALL_RECORDS';
export function toggleSkipAllRecords(skip) {
  return { skip: skip, type: TOGGLE_SKIP_ALL_RECORDS };
}

export const UPDATE_RECORD_PAGE = 'UPDATE_RECORD_PAGE';
export function updateRecordPage(page) {
  return { page, type: UPDATE_RECORD_PAGE };
}

export const UPDATE_RECORD = 'UPDATE_RECORD';
export function updateRecord(record) {
  return { record, type: UPDATE_RECORD };
}

export const UPDATE_EDITING_RECORD = 'UPDATE_EDITING_RECORD';
export function updateEditingRecord(record) {
  return { record, type: UPDATE_EDITING_RECORD };
}

export const START_UPDATE_RECORD = 'START_UPDATE_RECORD';
export function startUpdateRecord(record, editRow) {
  return { record, editRow, type: START_UPDATE_RECORD };
}

export const CANCEL_UPDATE_RECORD = 'CANCEL_UPDATE_RECORD';
export function cancelUpdateRecord() {
  return { type: CANCEL_UPDATE_RECORD };
}

function failedPreviewRecord(record, currentStep) {
  return record.previewStatus !== "error" && currentStep === "preview";
}

function failedReviewRecord(record, currentStep) {
  return record.status !== "failed" && currentStep === "review";
}

export function retrieveRunRecords() {
  return (dispatch, getState) => {
    const selectedFileId = getState().ui.selectedFileId;
    const currentStep = getState().ui.currentStep;

    const runRecordsPath = getState().paths.runRecordsPath;
    const page = getState().runRecords.recordPage;

    dispatch(startRetrieveRecords());
    get(`${runRecordsPath}?file_id=${selectedFileId}`, { params: { page: page } }).then((response) => {
      const { importSummary, meta } = response;
      const records = {};
      const recordIds = [];
      let failedRowsSorted = false;
      response.records.forEach((rec) => {
        if ((failedPreviewRecord(rec, currentStep) || failedReviewRecord(rec, currentStep)) && !failedRowsSorted) {
          failedRowsSorted = true;
          recordIds.sort();
        }

        rec.mappedFields = rec.mappedFields.map(f => camelCase(f));
        records[rec.id] = rec;
        recordIds.push(rec.id);
      });

      const headers = Object.keys(response.records[0].headerToFields);

      dispatch(setRecords(records, recordIds, meta, headers, importSummary));
    });
  };
}

export function handleSkipRecord(record) {
  return (dispatch, getState) => {
    const runRecordsPath = getState().paths.runRecordsPath;
    const skip = record.skip;
    dispatch(toggleSkipRecord(record.id));
    patch(`${runRecordsPath}/${record.id}`, {
      runRecord: {
        skip: !skip
      }
    });
  };
}


export function handleToggleSkipAllRecords() {
  return (dispatch, getState) => {
    const toggleSkipAllRecordsPath = getState().paths.toggleSkipAllRecordsPath;
    const selectedFileId = getState().ui.selectedFileId;
    const skip = getState().runRecords.meta.allRecordsSelected;
    dispatch(toggleSkipAllRecords(skip));
    post(`${toggleSkipAllRecordsPath}?file_id=${selectedFileId}`, {
      skip: skip
    });
  };
}

export function handleUpdateRecord(cancelUpdate = true) {
  return (dispatch, getState) => {
    const runRecordsPath = getState().paths.runRecordsPath;
    const currentStep = getState().ui.currentStep;
    const editingRecord = getState().runRecords.editingRecord;

    dispatch(updateRecord(editingRecord));
    const { mappedFields, headerToFields } = editingRecord;
    const fields = {};
    mappedFields.forEach(f => fields[f] = headerToFields[f]);
    patch(`${runRecordsPath}/${editingRecord.id}`, {
      runRecord: {
        fieldOverride: fields
      },
      updateTarget: currentStep == "review"
    }).then((response) => {
      const rec = { ...response.record };
      rec.mappedFields = rec.mappedFields.map(f => camelCase(f));

      dispatch(updateRecord(rec));
      if (cancelUpdate) dispatch(cancelUpdateRecord());
    });
  };
}
